import Brightness4Icon from '@mui/icons-material/Brightness4'
import Brightness7Icon from '@mui/icons-material/Brightness7'
import BrightnessAutoIcon from '@mui/icons-material/BrightnessAuto'
import { IconButton, Tooltip, useColorScheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

const ThemeModePicker = () => {
  const { t } = useTranslation()
  const { mode, setMode } = useColorScheme()
  return (
    <Tooltip
      title={mode === 'system' ? t('menus.autoMode') : mode === 'light' ? t('menus.lightMode') : t('menus.darkMode')}
    >
      <IconButton onClick={() => setMode(mode === 'system' ? 'light' : mode === 'light' ? 'dark' : 'system')}>
        {mode === 'system' ? <BrightnessAutoIcon /> : mode === 'dark' ? <Brightness4Icon /> : <Brightness7Icon />}
      </IconButton>
    </Tooltip>
  )
}

export default ThemeModePicker
